// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-radio-outer-circle {
  box-sizing: border-box;
  height: 16px !important;
  left: 3px !important;
  position: absolute;
  top: 0;
  transition: border-color ease 280ms;
  width: 16px !important;
  border-width: 2px;
  border-style: solid;
  border-radius: 50%;
}

.spacer {
  margin-right: 10px;
}

::ng-deep.rolelist.mat-mdc-checkbox {
  height: 16px;
  width: 16px;
  position: relative;
  right: 3%;
  bottom: 9%;
}
::ng-deep.rolelist.mat-mdc-checkbox .mdc-checkbox {
  width: 16px;
  height: 16px;
}
::ng-deep.rolelist.mat-mdc-checkbox .mdc-checkbox .mdc-checkbox__native-control:enabled:checked ~ .mdc-checkbox__background {
  border-color: #17a0b4 !important;
  background-color: #17a0b4 !important;
}
::ng-deep.rolelist.mat-mdc-checkbox .mdc-checkbox .mdc-checkbox__native-control:enabled ~ .mdc-checkbox__background .mdc-checkbox__checkmark {
  color: white;
}
::ng-deep.rolelist.mat-mdc-checkbox .mdc-label {
  font-size: 13px;
  margin-bottom: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 13vw;
}
::ng-deep.rolelist.mat-mdc-checkbox .mdc-checkbox__background {
  height: 16px;
  width: 16px;
}

::ng-deep.matrolelist.mat-mdc-list-item {
  height: 35px !important;
}

::ng-deep.checkall.mat-mdc-checkbox {
  right: 0% !important;
  bottom: 0% !important;
  width: 100% !important;
  height: 25px !important;
}
::ng-deep.checkall.mat-mdc-checkbox .mdc-form-field {
  width: 100% !important;
}

::ng-deep.radiolist.mat-mdc-radio-button .mdc-form-field .mdc-label {
  font-size: 13px;
  margin-bottom: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 12vw;
}
::ng-deep.radiolist.mat-mdc-radio-button .mdc-radio .mdc-radio__native-control:enabled:checked + .mdc-radio__background .mdc-radio__outer-circle {
  border-color: #17a0b4 !important;
}
::ng-deep.radiolist.mat-mdc-radio-button .mdc-radio .mdc-radio__native-control:enabled:checked + .mdc-radio__background .mdc-radio__inner-circle {
  border-color: #17a0b4 !important;
}

::ng-deep.agmatoutlinestyles.mat-mdc-form-field {
  width: 100%;
}
::ng-deep.agmatoutlinestyles.mat-mdc-form-field .mdc-text-field--outlined {
  padding: 6px !important;
  height: 31px !important;
}
::ng-deep.agmatoutlinestyles.mat-mdc-form-field .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex {
  height: 30px !important;
}
::ng-deep.agmatoutlinestyles.mat-mdc-form-field .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mdc-notched-outline .mdc-floating-label {
  font-size: 11px !important;
  padding-bottom: 24px;
}
::ng-deep.agmatoutlinestyles.mat-mdc-form-field .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-input-element {
  position: relative;
  font-size: 12px !important;
  bottom: 8px !important;
}
::ng-deep.agmatoutlinestyles.mat-mdc-form-field .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-form-field-infix {
  bottom: 11px !important;
}

::ng-deep.rolematselect {
  bottom: 5px !important;
  position: relative !important;
}

.pipeSearch_messages {
  height: 81vh !important;
}

.matcardheight {
  overflow-x: hidden;
  overflow-y: auto;
  height: 58vh;
  padding-left: 5%;
}`, "",{"version":3,"sources":["webpack://./src/app/userrole/userrole.component.scss","webpack://./src/variables.scss"],"names":[],"mappings":"AAWA;EACI,sBAAA;EACA,uBAAA;EACA,oBAAA;EACA,kBAAA;EACA,MAAA;EACA,mCAAA;EACA,sBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;AAVJ;;AAaA;EACI,kBAAA;AAVJ;;AAcA;EACI,YAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;AAXJ;AAYI;EACE,WAAA;EACA,YAAA;AAVN;AAWM;EACE,gCCvCI;EDwCJ,oCCxCI;AD+BZ;AAWM;EACE,YAAA;AATR;AAYM;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AAVR;AAYI;EACE,YAAA;EACA,WAAA;AAVN;;AAaE;EACE,uBAAA;AAVJ;;AAYE;EACE,oBAAA;EACA,qBAAA;EACA,sBAAA;EACA,uBAAA;AATJ;AAUI;EACE,sBAAA;AARN;;AAcM;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AAXR;AAeM;EACE,gCCrFI;ADwEZ;AAeM;EACE,gCCxFI;AD2EZ;;AAkBA;EACE,WAAA;AAfF;AAgBE;EACE,uBAAA;EACA,uBAAA;AAdJ;AAiBI;EACE,uBAAA;AAfN;AAgBM;EACI,0BAAA;EACA,oBAAA;AAdV;AAgBM;EACE,kBAAA;EACA,0BAAA;EACA,sBAAA;AAdR;AAgBM;EACE,uBAAA;AAdR;;AAmBA;EACE,sBAAA;EACA,6BAAA;AAhBF;;AAkBA;EACE,uBAAA;AAfF;;AAiBA;EACI,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;AAdJ","sourcesContent":["@import \"../../variables.scss\";\r\n\r\n// .mat-list-base .mat-list-item, .mat-list-base .mat-list-option {\r\n//     display: block;\r\n//     height: 28px!important;\r\n//     -webkit-tap-highlight-color: transparent;\r\n//     width: 100%;\r\n//     padding: 0;\r\n// }\r\n \r\n\r\n.mat-radio-outer-circle {\r\n    box-sizing: border-box;\r\n    height: 16px!important;\r\n    left: 3px!important;\r\n    position: absolute;\r\n    top: 0;\r\n    transition: border-color ease 280ms;\r\n    width: 16px!important;\r\n    border-width: 2px;\r\n    border-style: solid;\r\n    border-radius: 50%;\r\n}\r\n\r\n.spacer {\r\n    margin-right: 10px; \r\n}\r\n\r\n\r\n::ng-deep.rolelist.mat-mdc-checkbox {\r\n    height: 16px;\r\n    width: 16px;\r\n    position: relative;\r\n    right: 3%;\r\n    bottom: 9%;\r\n    .mdc-checkbox {\r\n      width: 16px;\r\n      height: 16px;\r\n      .mdc-checkbox__native-control:enabled:checked~.mdc-checkbox__background{\r\n        border-color: $btn-color;\r\n        background-color: $btn-color;\r\n      }\r\n      .mdc-checkbox__native-control:enabled~.mdc-checkbox__background .mdc-checkbox__checkmark {\r\n        color: white;\r\n    }\r\n    }\r\n      .mdc-label{\r\n        font-size: 13px;\r\n        margin-bottom: 0;\r\n        overflow: hidden;\r\n        white-space: nowrap;\r\n        text-overflow: ellipsis;\r\n        width: 13vw;\r\n      }\r\n    .mdc-checkbox__background{\r\n      height: 16px;\r\n      width: 16px;\r\n    }\r\n  }\r\n  ::ng-deep.matrolelist.mat-mdc-list-item{\r\n    height: 35px !important;\r\n  }\r\n  ::ng-deep.checkall.mat-mdc-checkbox {\r\n    right: 0%   !important;\r\n    bottom: 0% !important;\r\n    width: 100% !important;\r\n    height: 25px  !important;\r\n    .mdc-form-field{\r\n      width: 100% !important;\r\n    }\r\n  }\r\n  ::ng-deep.radiolist.mat-mdc-radio-button  \r\n  {\r\n    .mdc-form-field{\r\n      .mdc-label{\r\n        font-size: 13px;\r\n        margin-bottom: 0;\r\n        overflow: hidden;\r\n        white-space: nowrap;\r\n        text-overflow: ellipsis;\r\n        width: 12vw;\r\n      }\r\n    }\r\n    .mdc-radio .mdc-radio__native-control:enabled:checked+.mdc-radio__background{\r\n      .mdc-radio__outer-circle {\r\n        border-color:  $btn-color;\r\n      }\r\n      .mdc-radio__inner-circle{\r\n        border-color:  $btn-color;\r\n      }\r\n    }\r\n}\r\n\r\n::ng-deep.agmatoutlinestyles.mat-mdc-form-field{ \r\n  width: 100%;\r\n  .mdc-text-field--outlined {\r\n    padding: 6px !important;\r\n    height: 31px !important;\r\n  }\r\n  .mat-mdc-text-field-wrapper{\r\n    .mat-mdc-form-field-flex {\r\n      height: 30px !important;\r\n      .mdc-notched-outline .mdc-floating-label{\r\n          font-size: 11px !important;\r\n          padding-bottom: 24px;\r\n      }\r\n      .mat-mdc-input-element{\r\n        position: relative;\r\n        font-size: 12px !important;\r\n        bottom: 8px !important;\r\n      }\r\n      .mat-mdc-form-field-infix{\r\n        bottom: 11px !important;\r\n      }\r\n    }\r\n }\r\n}\r\n::ng-deep.rolematselect{\r\n  bottom: 5px !important;\r\n  position: relative !important;\r\n}\r\n.pipeSearch_messages{\r\n  height: 81vh !important;\r\n}\r\n.matcardheight{\r\n    overflow-x: hidden;\r\n    overflow-y: auto;\r\n    height: 58vh;\r\n    padding-left: 5%;\r\n}","$btn-color: #17a0b4 !important;\r\n$fontsize: 12px !important;\r\n$btntextcolor: white !important;\r\n$btnHeight: 28px !important;\r\n$inputHeight:30px !important;\r\n$inputfontsize:11px !important;\r\n$primary:#004bff;\r\n// $modalHeaderTitleFont: ;\r\n@mixin modalheaderTtext {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
